export const castToMoney = (num: number) => Math.round(num * 100) / 100
